// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  GearMove,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  encounterId: __t.u64().name("encounter_id"),
  pulseIndex: __t.u32().name("pulse_index"),
  heroId: __t.u64().name("hero_id"),
  get moves() {
    return __t.array(GearMove);
  },
  owner: __t.identity(),
});
